import { MessageProp } from 'types';

export const CONSTANTS = {
    LOADING: 'loading',
    IDLE: 'idle',
    FULFILLED: 'fulfilled',
    FAILED: 'failed'
};

export const SUCCESS_MESSAGES = {};

export const ERROR_MESSAGES = {
    API_ERROR: 'Unable to retrieve data'
};

export const SUBMIT_STEPS = ['personalData', 'peLicenceData', 'eventData', 'supportDocsData'];
export const PM_SUBMIT_STEPS = ['Profile_Information'];

export const ART_SEARCH_FIELDS = [
    {
        id: 'art-title',
        type: 'text',
        label: 'Title',
        tableColumn: 'title'
    },
    {
        id: 'art-company',
        type: 'text',
        label: 'Company Name',
        tableColumn: 'company_name'
    },
    {
        id: 'art-event',
        type: 'select',
        label: 'Event Type',
        tableColumn: 'event_type',
        menuItems: ['PLAY', 'Exhibition', 'Pop/Rock/Concert']
    },
    {
        id: 'art-language',
        type: 'select',
        label: 'Language',
        tableColumn: 'language',
        menuItems: ['English', 'Tamil', 'Malay']
    }
];

export const FILMS_SEARCH_FIELDS = [
    {
        id: 'films-title',
        type: 'text',
        label: 'Title',
        tableColumn: 'title'
    },
    {
        id: 'films-director',
        type: 'text',
        label: 'Director',
        tableColumn: 'director'
    },
    {
        id: 'films-year',
        type: 'select',
        label: 'Year',
        tableColumn: 'year',
        menuItems: ['2021', '2020', '2019', '2018', '2017', '2015', '2014', '2013', '2011']
    },
    {
        id: 'films-rating',
        type: 'select',
        label: 'Rating',
        tableColumn: 'rating',
        menuItems: ['PG', 'NC16', 'G', 'PG13', 'M18']
    }
];

export const GAMES_SEARCH_FIELDS = [
    {
        id: 'games-title',
        type: 'text',
        label: 'Title',
        tableColumn: 'title'
    },
    {
        id: 'games-rating',
        type: 'select',
        label: 'Rating',
        tableColumn: 'rating',
        menuItems: ['GENERAL', 'Advisory 16']
    },
    {
        id: 'games-platform',
        type: 'check',
        label: 'Platform',
        tableColumn: 'platform',
        menuItems: ['Xbox One', 'Xbox 360', 'Nintendo Switch', 'Sony Playstation 4', 'Xbox 360']
    }
];

export const ENQUIRY_TITLE = 'Enquiry for Classification Rating';

export const LOGIN_TEXT = 'Log in';
export const ENQUIRY_TEXT = 'Enquiry Classification';
export const EADVISOR_TEXT = 'eAdvisor Search';
export const GUIDE_TEXT = 'e-Advisor';
export const APP_TEXT = 'Applications';
export const DB_TEXT = 'Databases';
export const GUIDES_TEXT = 'Guides';
export const HELP_TEXT = 'Help and Support';

export const POSITIONOPTIONS = ['Content Assessor', 'EIP Officer', 'Registered Importers'];
export const LOGOUT_TEXT = 'Log Out';

export const DATABASELINKS = [
    { ref: '/databases/arts', title: 'Arts Entertainment Classification Database' },
    { ref: '/databases/films', title: 'Films Classification Database' },
    { ref: '/databases/video-games', title: 'Video Games Classification Database' },
    { ref: '/databases/registered-content-assessors-database', title: 'Registered Content Assessors Database (Films)' },
    { ref: '/databases/registered-importers-database-page', title: 'Registered Importers Database (Publications)' },
    { ref: '/databases/newspaper-register-search', title: 'Newspaper Register Search' }
];

export const TelecommunicationsDatabaseLinks = [
    { ref: '/databases/licence-search', title: 'Telecommunications Licence Database' },
    { ref: '/databases/equipment-search', title: 'Telecommunications Equipment Database' }
];

export const ProhibitedTelecomLinks = [
    { ref: '/databases/prohibited-telecommunication-equipment', title: 'Prohibited Telecommunication Equipment' }
];

export const OtherSubmodulesLinks = [{ ref: '/databases/others', title: 'Others' }];

export const messages = {
    SERVER_ERROR: {
        message: 'The system encountered a technical error.',
        subMessage: 'Please contact administrator.',
        variant: 'error'
    }
} as { [key: string]: MessageProp };

export const ExpiryConstants = {
    multiplier: 1000,
    minutes: 2
};

export const licenceList = [
    'Express Letter Services Class Licence',
    'Aircraft Station Licence',
    'Localised Private Network (Multi-Channel Radiocom Networks and Systems)',
    'Arts Entertainment Licence',
    'Localised Private Network Licence',
    'Localised Radio-Communication Station Licence',
    'General Radio-com Station Licence',
    'Ship Station Licence',
    'Amateur Station Licence',
    'Public Mobile Network Licence',
    'Satellite Communication Station Licence',
    'Ship Station Operator’s Certificate of Competency',
    'Wide-Area Private Network Licence',
    'Experimental Station Licence',
    'Telecommunication Dealer’s (Individual) Licence',
    'Telecommunication Dealer’s (Class) Licence',
    'General Equipment Registration (GER)',
    'Simplified Equipment Registration (SER)',
    'General Equipment Registration by Certification Bodies (GER-CB)',
    'Enhanced Simplified Equipment Registration (ESER)',
    'Confirmation of Conformity (COFC)',
    'Printing Press Licence',
    'Newspaper Permit',
    'Fixed Wireless Network Licence',
    'Special Purpose Station Licence',
    'Technical Trial (with use of Frequency)',
    'Temporary Use of Radio Frequency',
    'Services-Based Operations (Individual) Licence',
    'TV Receive-Only System Licence',
    'Film (Distribution/Exhibition) Licence',
    'Telecommunication Cable Detection Worker Licence',
    'Telecommunication Wiring Installer Class Licence',
    'Telecommunication Wiring Contractor Class Licence',
    'Exhibition of Telecommunication Equipment (without Frequency)',
    'Technical Trial (without use of Frequency)',
    'Exhibition of Telecommunication Equipment (with Frequency)',
    'Registration for Internet Access Service Providers And Resellers Class Licence',
    'Services-Based Operations (Class) Licence',
    'Radio Operator Exam',
    'Accreditation of Certification Authority',
    'Registration of Accounting Authority'
];

export const CASE_TYPE_ID = {
    FILMS: 'IMDA-FVGCS-Work-FVG-Films',
    VIDEO_GAMES: 'IMDA-FVGCS-Work-FVG-VideoGames',
    INTERACTIVE_SOFTWARE: 'IMDA-FVGCS-Work-FVG-VideoGames-Interactive'
};
